import { createTheme } from '@mui/material/styles'
import { color, themeColor } from './color'
import { typography } from './typography'

const material = createTheme()

export const RaGlobalRoot = {
  [material.breakpoints.up('md')]: {
    width: '100%',
  },
  ['& .MuiToolbar-root']: {
    alignItems: 'center',
    display: 'flex',
    fontFamily: typography.headline,
    minHeight: 'auto',
    backgroundColor: '#fff',
    borderRadius: 0,
    borderBottom: '1px solid ' + themeColor.slate10,
  },
}
